@if (!embeddedMode) {
<div class="inner-page-header">
  <h3>إضافة وحدة عقارية جديدة</h3>
</div>
}

<form [formGroup]="propertyUnitFormGroup">
  <div class="main-card">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/location.svg" class="label-icon" alt="location">
        <label class="form-label">
          تحديد موقع العقار<span class="red">*</span>
        </label>
      </div>
      <property-unit-location 
        [propertyDetailsFormGroup]="propertyUnitFormGroup">
      </property-unit-location>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/building.svg" class="label-icon" alt="building">
        <label class="form-label">
          تفاصيل العقار<span class="red">*</span>
        </label>
      </div>
      <div class="row unit-details-row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label unit-field-label">
              اسم العقار <span class="red">*</span>
            </label>
            <input 
              type="text" 
              class="form-control unit-input" 
              formControlName="custom_name"
              placeholder="اسم العقار لتمييزه مثال:شقة الياسمين في الرياض"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label unit-field-label">
              نوع العقار <span class="red">*</span>
            </label>
            <ng-select 
              bindLabel="name" 
              class="single-select unit-select" 
              placeholder="اختر نوع العقار"
              appendTo="body" 
              formControlName="building_type" 
              [searchable]="true" 
              [clearable]="true"
            >
              @for (type of buildingTypes; track type) {
                <ng-option [value]="type.id">
                  {{ type.name }}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label unit-field-label">
              المساحة (م²) <span class="red">*</span>
            </label>
            <div class="unit-input-wrapper">
              <input 
                type="number" 
                class="form-control unit-input unit-input-with-suffix" 
                formControlName="surfaces_space"
                placeholder="120"
              />
              <span class="input-suffix">م²</span>
            </div>
          </div>
        </div>
         <div class="col-md-6">
          <div class="form-group">
            <label class="form-label unit-field-label">
              عدد الأدوار 
            </label>
            <div class="unit-input-wrapper">
              <input 
                type="number" 
                class="form-control unit-input" 
                formControlName="floors_number"
                placeholder="عدد الأدوار"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/user.svg" class="label-icon" alt="user">
        <div class="label-content">
          <label class="form-label">
            من يتواجد مع الخبير أثناء الزيارة <span class="optional">(اختياري)</span>
          </label>
          <p class="label-subtitle">تمثيل العميل في الإجابة - يمكن اختيار أكثر من علاقة</p>
        </div>
      </div>
      <div class="representative-options">
        @for (relation of relationOptions; track relation.id) {
          <div 
            class="representative-option" 
            [class.active]="isSelected(relation.id)"
            (click)="toggleRelation(relation.id)"
          >
            <p class="option-label">{{ relation.name }}</p>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="main-card mt-2">
    <div class="col-12 property-unit-section form-group">
      <div class="custom-label">
        <img src="assets/images/svg/building.svg" class="label-icon" alt="building">
        <label class="form-label">
          بيانات المطور والمشروع <span class="optional">(اختياري)</span>
        </label>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="field-label">اسم المطور العقاري</label>
            <ng-select
              bindLabel="name_arabic"
              bindValue="pk"
              placeholder="يرجى اختيار المطور العقاري"
              appendTo="body"
              formControlName="developer_name"
              [searchable]="true"
              [clearable]="true"
              [virtualScroll]="true"
              (scrollToEnd)="onCompanyScroll()"
              (search)="onCompanySearch($event)"
              (change)="companyChanged($event)"
            >
              @for (company of companies; track company.pk) {
                <ng-option [value]="company.pk">
                  {{ company.name_arabic }}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="field-label">اسم المشروع</label>
            <ng-select
              bindLabel="name_ar"
              bindValue="id"
              placeholder="يرجى اختيار المشروع العقاري"
              appendTo="body"
              formControlName="project_name"
              [searchable]="true"
              [clearable]="true"
              [virtualScroll]="true"
            >
              @for (project of reProjects; track project.id) {
                <ng-option [value]="project.id">
                  {{ project.name_ar }}
                </ng-option>
              }
            </ng-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (errorMsg) {
  <div class="alert-box m-3">
    <img src="assets/images/svg/error-icon.svg" class="close-alert" (click)="closeError()" alt="" />
    <p class="alert-msg">{{ message }}</p>
  </div>
  }

  <div class="double-action mt-3">
    <button type="button" class="btn btn-grey" (click)="goBack()">إلغاء</button>
    <app-action-button [label]="'حفظ'" (submitAction)="save()"></app-action-button>
  </div>
</form>
